import { ONE_DRIVE_PRO } from './constants';
import { assertNever } from 'owa-assert';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import strings from 'owa-strings/owa-mail-strings';

export function getAttachmentPermissionLevelString(
    permissionLevel: AttachmentPermissionLevel,
    providerType: string
): string {
    switch (permissionLevel) {
        case AttachmentPermissionLevel.AnonymousView:
            return strings.AttachPerms_AnyoneCanView;
        case AttachmentPermissionLevel.AnonymousEdit:
            return strings.AttachPerms_AnyoneCanEdit;
        case AttachmentPermissionLevel.OrganizationEdit:
            return strings.AttachPerms_OrganizationEdit;
        case AttachmentPermissionLevel.OrganizationView:
            return strings.AttachPerms_OrganizationView;
        case AttachmentPermissionLevel.View:
            return providerType === ONE_DRIVE_PRO
                ? strings.AttachPerms_RecipientsCanView
                : strings.AttachPerms_AnyoneCanView;
        case AttachmentPermissionLevel.Edit:
            return providerType === ONE_DRIVE_PRO
                ? strings.AttachPerms_RecipientsCanEdit
                : strings.AttachPerms_AnyoneCanEdit;
        case AttachmentPermissionLevel.None:
            return strings.AttachPerms_NoPermissionToShare;
        default:
            return assertNever(permissionLevel);
    }
}
